import { Link } from "react-router-dom";
import type { Character } from "@/mocks/characters";

export default function CharacterCard({ character }: { character: Character }) {
  return (
    <Link
      to={`/character/${character.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300 hover:shadow-[0_10px_30px_-12px_rgba(224,94,78,0.35)]"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={character.avatar}
          alt={`${character.name} · ${character.title}`}
          title={`${character.name} ${character.title}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {character.race}
        </div>
        <div className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500/90 px-2.5 py-1 text-xs font-medium text-background-50">
          <i className="ri-fire-fill" aria-hidden="true"></i>
          {character.popularity}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-heading text-base font-bold text-foreground-950">{character.name}</h3>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{character.workName}</span>
        </div>
        <p className="text-xs text-primary-600">{character.title}</p>
        <div className="flex flex-wrap gap-1.5">
          {character.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{character.intro}</p>
      </div>
    </Link>
  );
}